import { render, staticRenderFns } from "./IpsTooltip.vue?vue&type=template&id=399c0b77"
import script from "./IpsTooltip.vue?vue&type=script&lang=js"
export * from "./IpsTooltip.vue?vue&type=script&lang=js"
import style0 from "./IpsTooltip.vue?vue&type=style&index=0&id=399c0b77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports